import { type OrganicStat } from "../../gql-generated/types";
import { getKeys } from "../../shared/utils/object";
import { type AgeStatsItem } from "../models";
import { ageGenderMap } from "../models/label-maps";

export const mapAgeData = (stats: readonly OrganicStat[]): AgeStatsItem<number>[] => {
    const ageDataArray: AgeStatsItem<number>[] = [];

    for (const key of getKeys(ageGenderMap)) {
        const men = stats.find(({ dimensionBreakdown }) => ageGenderMap[key]?.men === dimensionBreakdown);
        const women = stats.find(({ dimensionBreakdown }) => ageGenderMap[key]?.women === dimensionBreakdown);

        ageDataArray.push({
            men: Number.parseInt(men?.value ?? "0"),
            women: Number.parseInt(women?.value ?? "0"),
            dimensionBreakdown: key,
        });
    }

    return ageDataArray;
};
